import { Card, CardContent, IconBadge } from '@monksflow/monks-ui';
import type { TopInsightsSectionProps } from './TopInsightsSection.types';
import { SectionHeader } from '@/shared/ui/SectionHeader';
import { useTranslation } from 'react-i18next';

export const TopInsightsSection = ({ persona }: TopInsightsSectionProps) => {
  const { t } = useTranslation('audiences');

  const insights = persona.insightsData?.data.topInsights || [];

  if (insights.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-6">
      <SectionHeader title={t('audienceFlowWidget.topInsightsSection.topInsights')} />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {insights.map((insight, index) => (
          <Card
            key={`${index}-${insight.slice(0, 24)}`}
            variant="outline"
            className="shadow-none border-border-light"
          >
            <CardContent className="px-6 flex flex-col gap-3">
              <IconBadge variant="secondary">{index + 1}</IconBadge>
              <p className="type-body-md text-foreground-alt">{insight}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
